import client from './client';
import { allPages } from './allPages';

import {
  Submission,
  SubmissionDetail,
  SubmissionListResponse,
  SubmissionStatus,
} from './questionnaire.types';

// =============================================================================
// API Functions - Submission Management (Admin)
// =============================================================================

export async function getSubmissions(
  questionnaireId: number,
  options?: { skip?: number; limit?: number; status?: SubmissionStatus },
): Promise<SubmissionListResponse> {
  const params = new URLSearchParams();
  if (options?.skip !== undefined) params.append('skip', options.skip.toString());
  if (options?.limit !== undefined) params.append('limit', options.limit.toString());
  if (options?.status) params.append('status', options.status);

  const queryString = params.toString();
  const url = queryString
    ? `/questionnaires/${questionnaireId}/submissions?${queryString}`
    : `/questionnaires/${questionnaireId}/submissions`;

  const response = await client.get<SubmissionListResponse>(url);
  return response.data;
}

/** Every submission of a questionnaire, newest first. */
export const getAllSubmissions = (questionnaireId: number): Promise<Submission[]> =>
  allPages((skip, limit) => getSubmissions(questionnaireId, { skip, limit }).then((page) => page.submissions));

export async function getSubmissionDetails(
  questionnaireId: number,
  submissionId: number,
): Promise<SubmissionDetail> {
  const response = await client.get<SubmissionDetail>(
    `/questionnaires/${questionnaireId}/submissions/${submissionId}`,
  );
  return response.data;
}
